import { Injectable } from '@angular/core';
import { environment } from 'environments/environment.prod';

declare global {
interface Window { plausible: any; }
}

@Injectable()
export class PlausibleAnalyticsService {

  constructor() { }

  public trackButtonClick(name: string, properties?: any) {
    this.trackIfInProduction(name, properties);
  }

  private trackIfInProduction(name: string, properties?: any) {
    if (environment.production && window.plausible) {
      window.plausible(name, { props: properties });
    } else {
      console.warn("Plausible analytics is not available in testing/staging environment.");
    }
  }

}
